import { useEffect, useState } from 'react';
import logger from '@utils/logger';
import getConfig from 'next/config';

const {
  publicRuntimeConfig: { applePayMerchantId },
} = getConfig();

const useApplePayEligibility = () => {
  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);
  const [isCheckingApplePayAvailability, setIsCheckingApplePayAvailability] =
    useState(true);

  useEffect(() => {
    (async function checkApplePayAvailability() {
      if (!window.ApplePaySession) {
        setIsApplePayAvailable(false);

        return;
      }

      try {
        const isDeviceSupported = ApplePaySession.canMakePayments();
        const paymentCredentialStatus =
          await ApplePaySession.applePayCapabilities(applePayMerchantId);

        const isAvailable =
          isDeviceSupported &&
          paymentCredentialStatus.paymentCredentialStatus !==
            'applePayUnsupported';

        setIsApplePayAvailable(isAvailable);
      } catch (error) {
        setIsApplePayAvailable(false);
        logger.error('Failed to check Apple Pay availability', error);
      } finally {
        setIsCheckingApplePayAvailability(false);
      }
    })();
  }, []);

  return {
    isApplePayAvailable,
    isCheckingApplePayAvailability,
  };
};

export default useApplePayEligibility;
